import util from '../util'

let controller = 'SSOCadastros'
export default Object.assign({}, {
  ListarRecursos: function (dto) {
    return util.Axios.GetAll(controller + '/ListarRecursos')
  },
  ListarScopesParceiro: function (dto) {
    return util.Axios.GetAll(controller + '/ListarScopesParceiro', dto)
  },
  AtualizarRecursos: function (dto) {
    return util.Axios.Post(controller + '/AtualizarRecursos', dto)
  },
  RemoverRecursos: function (clientId, recurso) {
    let dto = { Nome: clientId, Recurso: recurso }
    return util.Axios.DeleteAll(controller + '/RemoverRecursos', dto)
  },
  VerificaClientHabilitado: function (dto) {
    return util.Axios.GetAll(controller + '/VerificaClientHabilitado', dto)
  },
})
